import { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Icons
import { FaTrash } from 'react-icons/fa';
// Components
import { IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
import MultiLanguageTextField from 'components/MultiLanguageTextField';
// Utilities
import { isRequired, noWhitespace } from 'utilities/validation';

type Props = {
  index: number;
  onDelete: (index:number) => void;
}

const AnswerOption:FC<Props> = ({ index, onDelete }) => {
  const { t } = useTranslation();

  const name = 'questionsSettings.answersOptions';

  const { watch, formState:{ errors } } = useFormContext();

  const getAnswerError = useCallback(() => {
    if ( !errors || !errors.questionsSettings ) return '';

    const answer = errors.questionsSettings.answersOptions[index];

    if ( !answer ) return '';

    return answer && answer.title ? answer.title.message : '';
    // eslint-disable-next-line
  }, [errors])();

  const handleDelete = () => {
    onDelete(index);
  }

  const watchedAnswer = watch(`${name}.${index}`);

  if (!watchedAnswer) return null;
  return (
    <div className="flex-grow">
      <div className="flex gap-4 mb-1">
        <MultiLanguageTextField
          rules={{ required: isRequired, validate: noWhitespace }}
          className="mb-0 flex-grow"
          name={`${name}.${index}.title`}
          label={`${t('labels.answer')} ${index + 1}`}
          required={true}
          error={Boolean(getAnswerError)}
          errorText={getAnswerError}
          customKey={`questionsSettings.answersOptions.${watchedAnswer.ref}.title`}
        />
        {typeof onDelete !== 'undefined' ? (
          <div>
            <span className="block mb-1 h-5"></span>
            <Tooltip title={t('buttons.removeAnswer')}>
              <IconButton
                onClick={handleDelete}
                ><FaTrash /></IconButton>
            </Tooltip>
          </div>
        ) : null}
      </div>
      <span className="divider"></span>
    </div>
  )
}

export default AnswerOption;
